// Stable per-browser device fingerprint stored in localStorage.
// Not cryptographically secure — used only as a soft signal for
// rate-limiting, suspicious-pattern detection, and device listings.
const KEY = "cashisle_device_id";

export const getDeviceId = (): string => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID().replace(/-/g, "");
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Private mode / storage blocked — return ephemeral id
    return "nostore" + Math.random().toString(36).slice(2, 12);
  }
};
